import { getBoardDetailProps } from "@/utils/serverProps/BoardDetailProps";
import Post from "@components/esg-guide/post/Esg-guide-post";

const PostId = ({ initialPostData, postId }) => {
  if (!initialPostData) return <div>데이터가 없습니다.</div>;

  return (
    <>
      <Post initialPostData={initialPostData} postId={postId} />
    </>
  );
};
export default PostId;

export const getServerSideProps = getBoardDetailProps;
